import { types } from 'mobx-state-tree';
import type { Instance } from 'mobx-state-tree/dist/core/type/type';

import { ProjectAssessmentType } from '@/enums/projects';
import { AdmissionModel } from '@/models/admissions';
import { ApplicationModel } from '@/models/applications';
import { IntChoiceFieldModel, TagModel } from '@/models/common';
import { CityModel } from '@/models/common';
import { HierarchicalTeamModel } from '@/models/teams';
import { UserModel } from '@/models/users';
import { edges, nullOrUndefined } from '@/models/utils';
import { BaseModel } from '@/stores/shared';
import type { AdmissionModelType } from '@/models/admissions';
import type { ApplicationModelType } from '@/models/applications';
import type { CityModelType, TagModelType } from '@/models/common';
import type { Edges } from '@/types/shared';

export const ProjectProblemModel = types.compose(
  BaseModel,
  types.model({
    definition: types.maybe(types.frozen()),
  }),
);

export type ProjectProblemModelType = Instance<typeof ProjectProblemModel> & {};

export const ProjectModel = types.compose(
  BaseModel,
  types.model({
    title: types.maybe(types.string),
    description: types.maybe(types.frozen()),
    candidateRequirements: types.maybe(types.frozen()),
    presentationLink: types.maybe(types.string),
    mentorContact: types.maybe(types.string),
    application: types.late(() => types.maybe(ApplicationModel)),
    season: types.late(() => types.maybe(AdmissionModel)),
    team: types.late(() => types.maybe(HierarchicalTeamModel)),
    mentors: types.maybe(edges(UserModel)),
    cities: types.maybe(edges(CityModel)),
    tags: types.maybe(edges(TagModel)),
    problems: types.maybe(edges(ProjectProblemModel)),
    language: types.maybe(types.string),
    assessmentType: nullOrUndefined(
      types.enumeration<ProjectAssessmentType>(
        Object.values(ProjectAssessmentType),
      ),
    ),
    testTaskTime: types.maybe(IntChoiceFieldModel),
  }),
);

export type ProjectModelType = Instance<typeof ProjectModel> & {
  application: ApplicationModelType;
};

export type MentorProjectModelType = Instance<typeof ProjectModel>;

export type ProjectWithRelatedObjectsModelType = ProjectModelType & {
  season: AdmissionModelType;
  tags: Edges<TagModelType>;
  cities: Edges<CityModelType>;
};
